import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["vkauth"];
import stages from '../stages';
export default (function (stage, callback) {
  if (window.S7vk) {
    var _window$S7vk = window.S7vk,
        apiId = _window$S7vk.apiId,
        domain = _window$S7vk.domain,
        pathAuth = _window$S7vk.path.auth,
        setMessage = _window$S7vk.setMessage;
    var redirect = "".concat(stages(stage), "/vk");
    var authUrl = "".concat(domain, "/").concat(pathAuth, "?client_id=").concat(apiId, "&display=popup&redirect_uri=").concat(redirect, "&response_type=code&openapi=1&scope=").concat(4194304 + 65536, "&state=").concat(redirect);
    window.open(authUrl, 'VK Auth', 'width=665,height=370');

    if (!setMessage) {
      window.addEventListener('message', function handleMessage(event) {
        if (redirect.indexOf(event.origin) >= 0) {
          var data = {};

          try {
            data = JSON.parse(event.data);
          } catch (error) {// do nothing
          }

          var _ref = data || {},
              vkauth = _ref.vkauth,
              response = _objectWithoutProperties(_ref, _excluded);

          if (vkauth && !response.error) {
            if (!response.error) {
              callback(response);
            }
          }

          setTimeout(function () {
            var _event$source;

            if (event !== null && event !== void 0 && (_event$source = event.source) !== null && _event$source !== void 0 && _event$source.close) {
              event.source.close();
            }
          }, 100);
        }
      });
      window.S7vk.setMessage = true;
    }
  }
});